var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.225 1.00605C1.57375 0.677671 2.14657 0.677671 2.49531 1.00605L6.76754 4.99795L11.0398 1.00605C11.3885 0.677671 11.9613 0.677671 12.3225 1.00605C12.6713 1.33443 12.6713 1.86684 12.3225 2.19521L7.40277 6.7817C7.05402 7.11008 6.48106 7.11008 6.13231 6.7817L1.225 2.19521C0.863801 1.86684 0.863801 1.33443 1.225 1.00605Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.7f22497712cfbcfa25e4b087a0730620.svg";
export { ForwardRef as ReactComponent };